{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Yeni ekip oluştur",
    "HEADER": "Ekipler",
    "LOADING": "Fetching teams",
    "DESCRIPTION": "Teams allow you to organize agents into groups based on their responsibilities. An agent can belong to multiple teams. When working collaboratively, you can assign conversations to specific teams.",
    "LEARN_MORE": "Learn more about teams",
    "LIST": {
      "404": "Bu hesap üzerine oluşturulmuş ekip bulunmamaktadır.",
      "EDIT_TEAM": "Ekibi düzenle",
      "NONE": "Hiç"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Yeni bir ekip oluştur",
        "DESC": "Ekibinize bir isim ve açıklama ekleyin."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Ekibinize temsilciler ekleyin",
        "TITLE": "Ekibe temsilciler ekleyin - {teamName}",
        "DESC": "Yeni oluşturduğunuz ekibe Temsilciler ekleyin. Bu özellik ekip olarak görüşme yapabilmenizi, aynı görüşmeye gelecek bildirimlerden haberdar olabilmenize olanak sağlar."
      },
      "WIZARD_CREATE": {
        "TITLE": "Yarat",
        "BODY": "Temsilcilerden yeni bir ekip oluştur."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Kullanıcı Ekle",
        "BODY": "Ekibe temsilciler ekleyin."
      },
      "WIZARD_FINISH": {
        "TITLE": "Son",
        "BODY": "Hepiniz gitmeye hazırsınız!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Ekibinizin detaylarını düzenleyin",
        "DESC": "Ekibinizin ismini ve açıklamasını düzenleyin.",
        "BUTTON_TEXT": "Ekibi güncelle"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Ekipteki temsilcileri güncelleyin",
        "TITLE": "Ekibe temsilciler ekleyin - {teamName}",
        "DESC": "Yeni oluşturduğunuz ekibe Temsilciler ekleyin. Bir görüşme bu ekibe atandığında tüm temsilcilere bildirim gider."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Ekip detayları",
        "ROUTE": "ayarlar_ekipler_duzenle",
        "BODY": "İsmi, açıklamayı ve diğer detayları düzenleyin."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Temsicileri Düzenle",
        "ROUTE": "ayarlar_ekipler_uyeleri_duzenle",
        "BODY": "Ekibinizdeki temsicileri düzenleyin."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Son",
        "ROUTE": "ayarlar_ekipler_son",
        "BODY": "Hepiniz gitmeye hazırsınız!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Ekip detayları kaydedilemedi. Tekrar deneyin."
    },
    "AGENTS": {
      "AGENT": "TEMSİLCİ",
      "EMAIL": "E-Posta",
      "BUTTON_TEXT": "Kullanıcı Ekle",
      "ADD_AGENTS": "Ekibinize Temsiciler Ekleniyor...",
      "SELECT": "seçiniz",
      "SELECT_ALL": "tüm temsicileri seçin",
      "SELECTED_COUNT": "{total} temsilciden {selected} temsilci seçildi."
    },
    "ADD": {
      "TITLE": "Ekibe temsilciler ekleyin - {teamName}",
      "DESC": "Yeni oluşturduğunuz ekibe Temsilciler ekleyin. Bu özellik ekip olarak görüşme yapabilmenizi, aynı görüşmeye gelecek bildirimlerden haberdar olabilmenize olanak sağlar.",
      "SELECT": "seçiniz",
      "SELECT_ALL": "tüm temsicileri seçin",
      "SELECTED_COUNT": "{total} temsilciden {selected} temsilci seçildi.",
      "BUTTON_TEXT": "Kullanıcı Ekle",
      "AGENT_VALIDATION_ERROR": "En az bir temsilci seçin."
    },
    "FINISH": {
      "TITLE": "Ekibiniz hazır!",
      "MESSAGE": "Artık görüşmelere takım olarak dahil olabilirsiniz. Mutlu görüşmeler ",
      "BUTTON_TEXT": "Son"
    },
    "DELETE": {
      "BUTTON_TEXT": "Sil",
      "API": {
        "SUCCESS_MESSAGE": "Ekip başarıyla silindi.",
        "ERROR_MESSAGE": "Ekip silinemiyor. Tekrar deneyin."
      },
      "CONFIRM": {
        "TITLE": "Are you sure you want to delete the team?",
        "PLACE_HOLDER": "Onaylamak için lütfen {teamName} yazınız",
        "MESSAGE": "Ekibi silmek aynı zamanda görüşmelere atanmış ekipleri de temizler.",
        "YES": "Sil ",
        "NO": "İptal Et"
      }
    },
    "SETTINGS": "Ayarlar",
    "FORM": {
      "UPDATE": "Ekibi güncelle",
      "CREATE": "Ekip oluştur",
      "NAME": {
        "LABEL": "Ekip İsmi",
        "PLACEHOLDER": "Örneğin: Satış, Müşteri Hizmetleri"
      },
      "DESCRIPTION": {
        "LABEL": "Ekip Açıklaması",
        "PLACEHOLDER": "Ekip hakkında kısa açıklama."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Bu ekip için otomatik atamayı etkinleştir."
      },
      "SUBMIT_CREATE": "Ekip oluştur"
    }
  }
}
